import { useState, useEffect } from 'react';
import config from '../config';

const slides = [
  {
    badge: "Finance Leadership",
    title: "Strategic Finance Leadership for SMB Growth",
    subtitle: "Our CFO consultants deliver real-time dashboards, KPI oversight, and strategic financial guidance customized to accelerate your business expansion in the U.S. market.",
    primaryBtn: "LEARN MORE ",
    secondaryBtn: "SCHEDULE CONSULTATION",
    backgroundImage: `${config.imageBaseURL}${config.paths.banners}104.webp`
  },
  {
    badge: "Virtual CFO Services ",
    title: "Elevate Your Finance Strategy with a Outsourced CFO",
    subtitle: "Our CFO consultants streamline your finance function by mapping workflows, automating reporting, and converting raw data into actionable intelligence so leadership can focus on scaling.",
    primaryBtn: "EXPLORE SERVICES",
    secondaryBtn: "GET STARTED",
    backgroundImage: `${config.imageBaseURL}${config.paths.banners}101.webp`
  },
  {
    badge: "Your vCFO in US",
    title: "Fractional CFO Services Across the United States",
    subtitle: "Our Virtual CFO partners identify and fix working capital gaps optimizing cash flow, strengthening controls, and aligning financial plans with your growth trajectory.",
    primaryBtn: "EXPLORE SERVICES",
    secondaryBtn: "GET STARTED",
    backgroundImage: `${config.imageBaseURL}${config.paths.banners}103.webp`
  },
  {
    badge: "Premium CFO Services",
    title: "ERP & Finance Tech Consulting by <br>On-Demand CFOs",
    subtitle: "From strategy to execution, our CFO consultants lead ERP rollouts and finance tech integrations, enabling automation, visibility, and readiness for funding, M&A, or transformation.",
    primaryBtn: "EXPLORE SERVICES",
    secondaryBtn: "GET STARTED",
    backgroundImage: `${config.imageBaseURL}${config.paths.banners}102.webp`
  },
  {
    badge: "Premium CFO Services",
    title: "Investor-Ready Reporting & Fundraising Support",
    subtitle: "Virtual CFOs deliver audit-ready statements, dynamic forecasts, and advance investor decks empowering founders to raise capital with clarity and confidence.",
    primaryBtn: "EXPLORE SERVICES",
    secondaryBtn: "GET STARTED",
    backgroundImage: `${config.imageBaseURL}${config.paths.banners}105.webp`
  }
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);


  useEffect(() => {
    // Preload images
    const preloadImages = async () => {
      const imagePromises = slides.map(slide => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve;
          img.src = slide.backgroundImage;
        });
      });

      await Promise.all(imagePromises);
    };

    preloadImages();
  }, []);

  // Auto-advance functionality disabled
  /*
  useEffect(() => {
    if (isLoading) return;
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 12000); // Auto-advance every 10 seconds

    return () => clearInterval(interval);
  }, [slides.length, isLoading]);
  */

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero-section" id="home">
      {/* Background Images */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-background ${index === currentSlide ? 'active' : ''}`}
          style={{
            backgroundImage: `url(${slide.backgroundImage})`,
            opacity: index === currentSlide ? 0.8 : 0,
            transition: 'opacity 1s ease-in-out'
          }}
        ></div>
      ))}

      <div className="hero-overlay"></div>

      {/* Navigation Arrows */}
      <button className="hero-nav-btn hero-prev" onClick={prevSlide} aria-label="Previous slide">
        <span className="nav-arrow">‹</span>
      </button>
      <button className="hero-nav-btn hero-next" onClick={nextSlide} aria-label="Next slide">
        <span className="nav-arrow">›</span>
      </button>

      <div className="container">
        <div className="hero-content">
          <div className="hero-slide-content" key={currentSlide}>
            {/* <div className="hero-badge">
              {slides[currentSlide].badge}
            </div>*/}

            <h1
              className="hero-title"
              dangerouslySetInnerHTML={{ __html: slides[currentSlide].title }}
            />

            <p className="hero-subtitle">
              {slides[currentSlide].subtitle}
            </p>

            <div className="hero-buttons">
              <a href="#services" className="btn btn-primary">
                {slides[currentSlide].primaryBtn}
              </a>
              <a href="#contact" className="btn btn-secondary">
                {slides[currentSlide].secondaryBtn}
              </a>
            </div>
          </div>
        </div>

        <div className="hero-pagination">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
